<input type="hidden" id="establishment-name" [value]="establishmentName" />
<router-outlet />
<!-- [backdropBackgroundColor]="'#d6d6d6'" -->
<!-- [backgroundColor]="'#ab2619'" -->
<!-- rgba(255, 255, 255, 0) -->
<ng-http-loader 
    [backdrop]="true"
    [backgroundColor]="'rgba(255, 255, 255, 0)'"
    [minDuration]="500"
    [backdropBackgroundColor]="'rgba(255, 255, 255, 0)'"
    [spinner]="spinkit.skSpinnerPulse">
</ng-http-loader>